import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});
const voteteService = {
  save(data) {
    const electionId = data.vote.electionId;
    const url = `/vote/${electionId}`;
    return new Promise((resolve, reject) => {
      axios
        .post(url, {
          identifier: data.vote.identifier,
          region: data.vote.region,
          votes: data.vote.votes,
          has_voted: data.vote.has_voted,
          ipAddress: data.vote.clientIp
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(response => {
          reject(response.status);
        });
    });
  },
  async get(idElection) {
    const url = `/votingreceipt/${idElection}`;
    const response = await axios.get(url);
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  }

};
export default voteteService;
